// @flow
import React from 'react';
import type { ChildrenArray, Element } from 'react';
import classnames from 'classnames';
import styles from './PlanOptionSubscribe.css';
import PlanImage from './PlanImage';
import PlanDetails from './PlanDetails';
import { FormattedMessage, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import { commonMessages } from '../messages/Common';

type OwnProps = {
  'id': string,
  'isSelected': boolean,
  'onSelect': Function,
  'children'?: ChildrenArray<Element<any>>,
  'imageTitle': string,
  'title'?: Element<typeof FormattedMessage>,
  'monthlyPrice': number,
  'relativeDiscount'?: number,
  'benefits': Array<Object>,
  'exclusions'?: Array<Object>,
  'planTag'?: Element<typeof FormattedMessage>,
  'className'?: string,
  'data-test'?: string,
  'isTrialAvailable': boolean,
  'trialDurationDays': number,
  'priceTag'?: Element<any>,
};

type Props = OwnProps & {
  intl: IntlShape,
};

const PlanOptionSubscribe = ({
  isSelected,
  onSelect,
  children,
  id,
  imageTitle,
  title,
  monthlyPrice,
  relativeDiscount,
  benefits,
  exclusions,
  className,
  planTag,
  'data-test': dataTest,
  intl,
  isTrialAvailable,
  trialDurationDays,
  priceTag,
}: Props) => {
  const containerClassname = classnames(styles.container, className, {
    [styles.isSelected]: isSelected,
  });

  return (
    <div className={containerClassname} data-test={dataTest}>
      <div className={styles.plan}>
        <button
          onClick={() => onSelect(id)}
          className="dummy-btn"
          aria-label={
            isSelected
              ? intl.formatMessage(commonMessages.deselect, { title: imageTitle })
              : intl.formatMessage(commonMessages.select, { title: imageTitle })
          }
        />
        <PlanImage id={id} imageTitle={imageTitle} isSelected={isSelected} planTag={planTag} />
        <PlanDetails
          title={title}
          monthlyPrice={monthlyPrice}
          relativeDiscount={relativeDiscount}
          benefits={benefits}
          exclusions={exclusions}
          planTag={planTag}
          isTrialAvailable={isTrialAvailable}
          trialDurationDays={trialDurationDays}
          priceTag={priceTag}
        />
      </div>
      {children}
    </div>
  );
};

export default injectIntl(PlanOptionSubscribe);
